<template>
  <v-combobox
    :label="label"
    :value="value"
    :items="candidate"
    :loading="loading"
    :disabled="disabled"
    :rules="rules"
    @change="onSelected"
    no-data
    filled
    dense
    :attach="attach"
  >
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-title>※入力されたタイトルは新たなタイトルとして登録されます</v-list-item-title>
      </v-list-item>
    </template></v-combobox
  >
</template>

<script>
export default {
  name: "ProductTitleField",
  model: { prop: "value", event: "selected" },
  props: {
    label: { type: String, default: "タイトル" },
    value: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    attach: { type: Boolean, default: true },
    rules: { type: Array, default: () => [] },
  },
  data() {
    return {
      loading: null,
      candidate: [],
      current: null,
    };
  },
  async mounted() {
    await this.setup();
  },
  methods: {
    async setup() {
      try {
        this.loading = true;
        const response = await this.$store.dispatch("product/searchTitleList");
        if (response.data?.contents?.titles) {
          this.candidate = response.data.contents.titles;
        } else {
          this.candidate = [];
        }
      } catch (error) {
        console.error("TitleField::setup", error);
      } finally {
        this.loading = false;
      }
    },
    onSelected(value) {
      if (value) {
        this.$emit("selected", value);
      } else {
        this.$emit("selected", null);
      }
    },
  },
};
</script>
